module.exports = __webpack_public_path__ + "img/failure.806f37dc.svg";